import request from '@/utils/axios'
//签名列表
export function getSignList (params) {
  return request({
    url: '/api/getsignlist',
    method: 'get',
    params
  })
}